export default function addNewTab() {
  var links = document.querySelectorAll('main a');
  for (var i = 0; i < links.length; i++) {
    var el = links[i];
    if (el.hostname !== '' && el.hostname !== location.hostname) {
      el.classList.add('external-link');
      el.setAttribute('target', '_blank');
      el.setAttribute('aria-describedby', 'external-disclaimer');
      if (el.getAttribute('title') === undefined) {
        el.setAttribute('title', '(opens new window)')
      }
    }
  }
}
